<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="!message && request">
                    <h2>Continue to RelayMD</h2>
                    <ng-container *ngIf="account; else loading">
                        <div class="account">
                            <div class="initials" aria-hidden="true">{{ account.initials }}</div>
                            <div class="who">
                                <strong>{{ account.name }}</strong>
                                <span *ngIf="account.email">{{ account.email }}</span>
                            </div>
                        </div>
                        <button mat-flat-button color="primary" [disabled]="sending" (click)="continue()">Continue as {{ account.name }}</button>
                        <button mat-button class="switch" [disabled]="sending" (click)="switchAccount()">Use a different account</button>
                        <p class="note">Only continue if you opened this from the RelayMD app on this phone.</p>
                    </ng-container>
                    <ng-template #loading>
                        <p class="note">Loading your MedicAI account…</p>
                    </ng-template>
                </div>
                <div *ngIf="message">
                    <h2>RelayMD</h2>
                    <p>{{ message }}</p>
                    <button *ngIf="signInFirst" mat-flat-button color="primary" (click)="signIn()">Sign in to MedicAI</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
